const story = `Our journey began with a simple vision — to bridge the gap between people and the places they dream of calling home. From our roots here at home to opportunities abroad, we’ve grown with one mission: making real estate seamless, trustworthy, and tailored to every client’s needs.

What sets us apart isn’t just our knowledge of markets both local and international, but our commitment to people. We believe a property is more than land or walls — it’s security, it’s lifestyle, it’s legacy.

Over the years, we’ve built relationships, not just transactions. Whether it’s helping a family find their first home, guiding an investor into global opportunities, or supporting a business in establishing its footprint, we walk side by side with our clients through every step.

Today, our brand stands as a trusted partner for real estate at home and abroad — driven by integrity, powered by expertise, and grounded in the belief that everyone deserves a place to truly belong.`;

const OurStory = () => {
  return (
    <div className="bg-textWhite py-2.5 px-5 lg:px-[54px]">
      <div className="py-10 lg:py-0 p-2.5 flex flex-col lg:flex-row items-center gap-6">
        <div className="w-full lg:w-1/2 flex flex-col gap-3.5">
          <h3 className="text-textBlack text-[36px] font-poppins font-semibold">
            Our Story
          </h3>
          <p className="whitespace-pre-line text-textBlack3 leading-[20px] tracking-[0%] font-poppins">
            {story}
          </p>
        </div>
        <div className="w-full lg:w-1/2">
          <img src="/assets/images/the-team.svg" className="w-full" alt="" />
        </div>
      </div>
    </div>
  );
};

export default OurStory;
